export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=70a0120909b13ada128686ab6556b1c71c02e3715e&name=pushAdClickData!'